import { render, staticRenderFns } from "./InboxTicketTable.vue?vue&type=template&id=9121c4c8&scoped=true&"
import script from "./InboxTicketTable.vue?vue&type=script&lang=ts&"
export * from "./InboxTicketTable.vue?vue&type=script&lang=ts&"
import style0 from "./InboxTicketTable.vue?vue&type=style&index=0&id=9121c4c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9121c4c8",
  null
  
)

export default component.exports